/**
 * Etichete RO pentru enumurile afișate în UI (frontend nu importă @hepaderm/common).
 * Rămâne în sync cu packages/common/src/constants/enum-labels.ts.
 */
const LABELS: Record<string, string> = {
  // Program
  DERMATO: 'Dermato',
  HEPATO: 'Hepato',
  BOTH: 'Dermato + Hepato',
  // Status formular
  DRAFT: 'Ciornă',
  SUBMITTED: 'Trimis',
  REVIEWED: 'Revizuit',
  ARCHIVED: 'Arhivat',
  // Status pacient / utilizator
  ACTIVE: 'Activ',
  INACTIVE: 'Inactiv',
  SUSPENDED: 'Suspendat',
  DECEASED: 'Decedat',
  // Fitzpatrick
  TYPE_I: 'Tip I',
  TYPE_II: 'Tip II',
  TYPE_III: 'Tip III',
  TYPE_IV: 'Tip IV',
  TYPE_V: 'Tip V',
  TYPE_VI: 'Tip VI',
  // Status leziune
  NEW: 'Nouă',
  MONITORING: 'În monitorizare',
  SUSPECT: 'Suspectă',
  BENIGN: 'Benignă',
  MALIGNANT: 'Malignă',
  // Screening
  NEGATIVE: 'Negativ',
  POSITIVE: 'Pozitiv',
  INCONCLUSIVE: 'Inconcludent',
  SCREENING_REFUZAT: 'Exclus din program',
  NO_LESIONS: 'Fără leziuni',
  // Status de revenire (ReturnStatus)
  RECONTROL_PROGRAMAT: 'Recontrol programat',
  MONITORIZARE: 'În monitorizare',
  FARA_REVENIRE: 'Fără revenire recomandată',
  // Lateralitate
  LEFT: 'Stânga',
  RIGHT: 'Dreapta',
  MIDLINE: 'Median',
  BILATERAL: 'Bilateral',
};

/** Returnează eticheta RO pentru o valoare enum; valorile necunoscute se întorc neschimbate. */
export function enumLabel(value: string | null | undefined): string {
  if (!value) return '—';
  return LABELS[value] ?? value;
}
